import { NgDompurifySanitizer } from '@tinkoff/ng-dompurify';
import {
  TuiRootModule,
  TuiDialogModule,
  TUI_SANITIZER
} from '@taiga-ui/core';
import {
  NgModule
} from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule
} from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { TokenInterceptor } from './http-interceptors/token-interceptor';
import { UserInterceptor } from './http-interceptors/user-interceptor';
import { AppRoutingModule } from './app-routing.module';
import { UncommonModule } from './common/common.module';
import { ServerErrorsInterceptor } from './http-interceptors/server-errors.interceptor';
import { CoreModule } from './core/core.module';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { environment } from 'environments/environment';

import { ExternalModule } from './pages/external/external.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    UncommonModule,
    CoreModule,
    environment.production ? [] : AkitaNgDevtools.forRoot(),
    TuiRootModule,
    TuiDialogModule,
    ExternalModule
  ],
  bootstrap: [AppComponent],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: UserInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ServerErrorsInterceptor, multi: true},
    {provide: TUI_SANITIZER, useClass: NgDompurifySanitizer}
  ]
})

export class AppModule {
}
